webpackJsonp([100],{

/***/ 2453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterPostScreen_vue__ = __webpack_require__(3636);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e14dac2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterPostScreen_vue__ = __webpack_require__(4405);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4403)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterPostScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e14dac2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterPostScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/account/RegisterPostScreen.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e14dac2", Component.options)
  } else {
    hotAPI.reload("data-v-3e14dac2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_platformNames__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["m" /* BForm */], BAlert: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* BAlert */], BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */], BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */], BIconEyeSlash: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["W" /* BIconEyeSlash */], BIconEye: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["V" /* BIconEye */]
  },
  data: function data() {
    return {
      inOpenlegal: __WEBPACK_IMPORTED_MODULE_1__constants_platformNames__["j" /* inOpenlegal */]
    };
  },

  props: {
    email: {
      type: String,
      required: false
    },
    confirmSucessful: {
      type: Boolean,
      required: false,
      default: true
    }
  }
});

/***/ }),

/***/ 4403:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("630ce584", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e14dac2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RegisterPostScreen.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3e14dac2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RegisterPostScreen.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.confirm-together p{margin:0\n}\n", ""]);

// exports


/***/ }),

/***/ 4405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$route.query.confirmSucessful
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "confirm-together",
              staticStyle: { "margin-bottom": "1.5rem", "margin-top": "2rem" }
            },
            [
              _c("p", {
                staticStyle: { display: "inline-block" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("signup.ok", {
                      email:
                        "<span style='color:#3238C4'>" +
                        _vm.$route.query.email +
                        "</span>"
                    })
                  )
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "1.5rem" } }, [
            _c("h6", [_vm._v(_vm._s(_vm.$t("signup.modal3")))])
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-bottom": "1.5rem" } }, [
            !_vm.inOpenlegal()
              ? _c("h6", {
                  staticStyle: { display: "inline-block" },
                  domProps: { innerHTML: _vm._s(_vm.$t("signup.modal4")) }
                })
              : _c("h6", {
                  staticStyle: { display: "inline-block" },
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("signup.modal4-openlegal"))
                  }
                })
          ])
        ])
      : _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("account.confirm-account-error")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e14dac2", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/100.4c2bb33e63b31cd3f969.js